import type { ModuleDefinition } from '../../../app/moduleRegistry';
import { cityModule } from './city';
import { populerCityModule } from './populerCity';
import { cheapestDestinationModule } from './cheapestDestination';
import { destinationModule } from './destination';
import { campaignModule } from './campaign';

/**
 * CMS CONTENT admin screens (City / PopulerCity / CheapestDestination / Destination /
 * Campaign) — the "B2C content management" half of the CMS module, gated behind
 * `HasCmsB2C` (Master-GSA-only). All 5 sub-modules now contribute empty `routes`/`menuItems`
 * arrays: their list pages are rendered as tabs inside `SiteDetailPage`
 * (see ../site/site/pages/SiteDetailPage.tsx) instead of standalone routed pages, so this
 * aggregator resolves to `{routes: [], menuItems: []}` — kept only so
 * `modules/cms/index.tsx` still has a single `cmsContentModule` to combine with the sibling
 * `cmsSiteModule`, matching the aggregator pattern used elsewhere in this codebase (see
 * modules/corporate/index.tsx and modules/system/index.tsx). `DestinationDetail` and
 * `CampaignDetail` were never separate sub-modules here — both resources have no standalone
 * list route in the real API (confirmed via a full swagger `/Cms/*` path scan, see
 * api/types/cmsContent.ts's file header), so their CRUD only exists nested inside the
 * Destination/Campaign edit dialogs (see destination/components/DestinationDetailsSection.tsx
 * and campaign/components/CampaignDetailsSection.tsx).
 */
const subModules: ModuleDefinition[] = [
  cityModule,
  populerCityModule,
  cheapestDestinationModule,
  destinationModule,
  campaignModule,
];

export const cmsContentModule: ModuleDefinition = {
  routes: subModules.flatMap((m) => m.routes),
  menuItems: subModules.flatMap((m) => m.menuItems),
};
